import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaComponent } from './recaptcha.component';
import { RecaptchaService } from './recaptcha.service';
import { UtilsModule } from '../utils/utils.module';

@NgModule({
  imports: [
    CommonModule,
    UtilsModule,
  ],
  declarations: [
    RecaptchaComponent,
  ],
  providers: [
    RecaptchaService,
  ],
  exports: [
    RecaptchaComponent,
  ]
})
export class RecaptchaModule {}
